import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json'
  }
});

let csrfToken = null;

export const setCsrfToken = (token) => {
  csrfToken = token;
  if (token) {
    api.defaults.headers.common['X-CSRF-Token'] = token;
  } else {
    delete api.defaults.headers.common['X-CSRF-Token'];
  }
};

export const getCsrfToken = () => csrfToken;

// Response interceptor
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      const requestUrl = error.config?.url || '';
      const isAuthRoute = requestUrl.includes('/auth/login') || requestUrl.includes('/auth/csrf');
      const onLoginPage = window.location?.pathname === '/login';
      if (!isAuthRoute && !onLoginPage) {
        // Unauthorized - redirect to login
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
